import { render, staticRenderFns } from "./sendman.vue?vue&type=template&id=5779d7f5&scoped=true&"
import script from "./sendman.vue?vue&type=script&lang=js&"
export * from "./sendman.vue?vue&type=script&lang=js&"
import style0 from "./sendman.vue?vue&type=style&index=0&id=5779d7f5&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5779d7f5",
  null
  
)

export default component.exports